<div>
    <div class="modal-header" style="padding: 0px;">
        <div class="modal-title" id="exampleModalLabel">
            <mat-form-field  style="margin-right: auto;" fxFlex="40%">
                <input matInput type="text" (keyup)="doFilter($event.target.value)" placeholder="Search">
            </mat-form-field>
        </div>
        <button
          type="button" mat-button
          (click)="close()" style="background-color: transparent;
          background-repeat: no-repeat;
          border: none;
          color: red;
          cursor: pointer;
          overflow: hidden;
          outline: none;"
        > <i class="fa fa-times"></i></button>
    </div>

    <!--Status Tile Pop-up-->
    <ngx-ui-loader [loaderId]="'tile'"></ngx-ui-loader>
    <div class="row" style="margin-top: 1%" *ngIf="isTile">
        <div class="col-md-12">
            <div>
                <ng-container>
                    <div *ngIf="isTileData else noData">
                        <table mat-table [dataSource]="dataSource" matSort class="example-container mat-elevation-z8" style="width: auto; height: auto; text-align: center;" >
                            <!-- FeederID Column -->
                            <ng-container matColumnDef="FeederID">
                                <th mat-header-cell *matHeaderCellDef style="text-align: center; cursor: pointer; font-weight: bold; background-color: wheat;">
                                    FeederID
                                </th>
                                <td mat-cell *matCellDef="let element" style="cursor: pointer;">
                                    {{element.id}}
                                </td>
                            </ng-container>

                            <!--Sitename Column-->
                            <ng-container matColumnDef="SiteName">
                                <th mat-header-cell *matHeaderCellDef style="text-align: center; cursor: pointer; font-weight: bold; background-color: wheat;">
                                    SiteName
                                </th>
                                <td mat-cell *matCellDef="let element" style="cursor: pointer;">
                                    {{element.sitename}}
                                </td>
                            </ng-container>

                            <!--KVA RATING COLUMN-->
                            <ng-container matColumnDef="KVARating">
                                <th mat-header-cell *matHeaderCellDef style="text-align: center; cursor: pointer; font-weight: bold; background-color: wheat;">
                                    KVARating
                                </th>
                                <td mat-cell *matCellDef="let element" style="cursor: pointer;">
                                    {{element.rating}}
                                </td>
                            </ng-container>

                            <!--Last Update Time Column-->
                            <ng-container matColumnDef="LastUpdatedTime">
                                <th mat-header-cell *matHeaderCellDef style="text-align: center; cursor: pointer; font-weight: bold; background-color: wheat;">
                                    LastUpdatedTime
                                </th>
                                <td mat-cell *matCellDef="let element" style="cursor: pointer;">
                                    {{element.date}}
                                </td>
                            </ng-container>

                            <!--STATUS COLUMN-->
                            <ng-container matColumnDef="Status">
                                <th mat-header-cell *matHeaderCellDef style="text-align: center; cursor: pointer; font-weight: bold; background-color: wheat;">
                                    Status
                                </th>
                                <td mat-cell *matCellDef="let element" style="cursor: pointer;" (mouseenter) = "alertdata(element.id)">
                                    <span [ngStyle]="{'color': getStatusColor(element.status), 'animation': 'none', 'transition': 'none', 'font-size': '16px'}" [matTooltip]="alerts" matTooltipPosition="above"  matTooltipClass="auto-adjust-tooltip">
                                        ●
                                    </span>
                                    
                                </td>
                            </ng-container>

                            <!-- Header and Row Definitions -->
                            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

                        </table>
                    </div>
                    
                    <!--ELSE CONDITION-->
                    <ng-template #noData>
                        <div style="font-size: 1.5em;text-align: center;width:100%;display: block;">
                            No Data<br>
                            <img src="assets/images/warning.gif" alt="Warning" style="height: 35vh;">
                        </div>
                    </ng-template>
                </ng-container>
            </div>
        </div>
    </div>


    <!--Alert Pop-up-->
    <ngx-ui-loader [loaderId]="'alert'"></ngx-ui-loader>
    <div *ngIf="isAlert" class="row" style="margin-top: 1%">
        <div class="col-md-12">
            <div>
                <ng-container>
                    <div *ngIf="isAlertData else noAlert">
                        <table mat-table [dataSource]="dataSource" matSort class="example-container mat-elevation-z8" style="width: auto; height: auto; text-align: center;" >
                    
                    
                            <ng-container matColumnDef="FeederID">
                                <th mat-header-cell *matHeaderCellDef style="text-align: center; cursor: pointer; font-weight: bold; background-color: wheat;">
                                    FeederID
                                </th>
                                <td mat-cell *matCellDef="let element" style="cursor: pointer;">
                                    {{element.feederID}}
                                </td>
                            </ng-container>
                            
                            
                            <ng-container matColumnDef="SiteName">
                                <th mat-header-cell *matHeaderCellDef style="text-align: center; cursor: pointer; font-weight: bold; background-color: wheat;">
                                    SiteName
                                </th>
                                <td mat-cell *matCellDef="let element" style="cursor: pointer;">
                                    {{element.sitename}}
                                </td>
                            </ng-container>
        
                            <ng-container matColumnDef="ParamName">
                                <th mat-header-cell *matHeaderCellDef style="text-align: center; cursor: pointer; font-weight: bold; background-color: wheat;">
                                    ParamName
                                </th>
                                <td mat-cell *matCellDef="let element" style="cursor: pointer;">
                                    {{element.paramName}}
                                </td>
                            </ng-container>
        
                            <ng-container matColumnDef="ActualValue">
                                <th mat-header-cell *matHeaderCellDef style="text-align: center; cursor: pointer; font-weight: bold; background-color: wheat;">
                                    ActualValue
                                </th>
                                <td mat-cell *matCellDef="let element" style="cursor: pointer;">
                                    {{element.actualValue}}
                                </td>
                            </ng-container>
        
                            <ng-container matColumnDef="ThresholdValue">
                                <th mat-header-cell *matHeaderCellDef style="text-align: center; cursor: pointer; font-weight: bold; background-color: wheat;">
                                    ThresholdValue
                                </th>
                                <td mat-cell *matCellDef="let element" style="cursor: pointer;">
                                    {{element.thresholdValue}}
                                </td>
                            </ng-container>
                            
                            
                            <tr mat-header-row *matHeaderRowDef="displayedColumnsAlert"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayedColumnsAlert;"></tr>
                            
                        </table>
                    </div>
                    
                    <!--ELSE STATEMENT-->
                    <ng-template #noAlert>
                        <div style="font-size: 1.5em;text-align: center;width:100%;display: block;">
                            No Data<br>
                            <img src="assets/images/warning.gif" alt="Warning" style="height: 35vh;">
                        </div>
                    </ng-template>
                </ng-container>
            </div>
        </div>
    </div>
</div>
